import { render, staticRenderFns } from "./AlternateSupplierView.vue?vue&type=template&id=9599b622"
import script from "./AlternateSupplierView.vue?vue&type=script&lang=js"
export * from "./AlternateSupplierView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports